import { Component, Input, ViewChild, AfterViewInit, OnDestroy, ElementRef } from '@angular/core'
import { Chart, ChartConfiguration, ChartOptions, ChartType } from 'chart.js'
import { BaseChartDirective, NgChartsModule } from 'ng2-charts'
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-bar-chart',
  standalone: true,
  imports: [NgChartsModule, NzSkeletonModule, CommonModule],
  templateUrl: './bar-chart.component.html',
  styleUrl: './bar-chart.component.scss'
})
export class BarChartComponent implements AfterViewInit, OnDestroy {
  @ViewChild(BaseChartDirective) chartDirective?: BaseChartDirective
  public barChartType: ChartType = 'bar'
  @Input() expanded: boolean = false;
  @Input() isMonitorMode: boolean = false;
  @Input() loading: boolean = false;
  @Input() public barChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    scales: {
      x: { title: { display: true, text: '' }, grid: { display: false } },
      y: { title: { display: true, text: '' }, grid: { display: false } }
    },
    plugins: {
      legend: { position: 'bottom' }
    }
  }
  @Input() public barChartData: ChartConfiguration['data'] = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
    datasets: [
      {
        data: [10, 41, 35, 51, 49, 62, 69, 91, 148],
        label: 'Check-lists',
        borderWidth: 1,
        borderRadius: 10
      }
    ]
  }
  public barChartLegend = true
  public barChartPlugins = []

  private chartInstance?: Chart
  private resizeObserver?: ResizeObserver

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.resizeObserver = new ResizeObserver(() => {
      this.resizeChart()
    })
    this.resizeObserver.observe(this.el.nativeElement)
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect()
  }

  public onChartInit (chart: Chart): void {
    this.chartInstance = chart
  }

  public resizeChart (): void {
    if (this.chartInstance) {
      this.chartInstance.resize()
    }
  }
}
